module.exports = __webpack_public_path__ + "static/media/HeroSweetPotatoSalad.26e85306.jpg";